<template>
  <div>
    <Navbar
      :token="token"
      :transferShoppingCarQty="shopping_car_qty"
      @searchKeyword="searchKeyword"
    />
    <ContentHeader :page_name="$route.name" @searchProduct="searchProduct" />
    <router-view
      :key="$route.fullPath"
      :isMobile="isMobile"
      :token="token"
      :search_product="search_product"
      :search_keyword="search_keyword"
      @shoppingCarQty="shoppingCarQty"
    ></router-view>
    <footer class="py-2 bg-platform_main text-white">
      <b-container>
        <div class="d-flex justify-content-between">
          <small
            >© {{ new Date().getFullYear() }} Quarter Car Part.版權所有。</small
          >
          <small>v{{ version }}</small>
        </div>
      </b-container>
    </footer>
  </div>
</template>
<style lang="scss">
.b-sidebar {
  height: calc(var(--vh, 1vh) * 100) !important;
}
</style>
<script>
import Navbar from "@/components/platform/Navbar.vue";
import ContentHeader from "@/components/platform/ContentHeader.vue";

export default {
  name: "Platform",
  components: {
    Navbar,
    ContentHeader
  },
  data() {
    return {
      isMobile: false,
      token: null,
      search_product: null,
      shopping_car_qty: 0,
      search_keyword: "",
      version: process.env.VUE_APP_VERSION
    };
  },
  created() {
    this.token = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("platform-api_token")
      }
    };
  },
  methods: {
    resizeWindowWidth() {
      if (window.innerWidth < 767.98) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    searchProduct(data) {
      this.search_product = data;
      setTimeout(() => {
        this.search_product = null;
      }, 1000);
    },
    shoppingCarQty(data) {
      this.shopping_car_qty = data;
    },
    searchKeyword(text) {
      this.search_keyword = text;
    }
  },
  mounted() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    this.resizeWindowWidth();
    document.querySelector("body").className = "";
    window.addEventListener("resize", () =>
      setTimeout(() => {
        vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
        this.resizeWindowWidth();
      }, 100)
    );
  }
};
</script>
